import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface RibbonContextType {
  ribbonContent: ReactNode | null;
  setRibbonContent: (content: ReactNode | null) => void;
  headerMetaContent: ReactNode | null;
  setHeaderMetaContent: (content: ReactNode | null) => void;
}

const RibbonContext = createContext<RibbonContextType | undefined>(undefined);

export const RibbonProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [ribbonContent, setRibbonContent] = useState<ReactNode | null>(null);
  const [headerMetaContent, setHeaderMetaContent] = useState<ReactNode | null>(null);

  const value = useMemo(
    () => ({ ribbonContent, setRibbonContent, headerMetaContent, setHeaderMetaContent }),
    [ribbonContent, headerMetaContent]
  );

  return (
    <RibbonContext.Provider value={value}>
      {children}
    </RibbonContext.Provider>
  );
};

export const useRibbon = () => {
  const context = useContext(RibbonContext);
  if (!context) {
    throw new Error('useRibbon must be used within RibbonProvider');
  }
  return context;
};
